module.exports = __webpack_public_path__ + "static/images/trend-up-arrow-bold.f71c65c8d72c865840e6d1cfbeabf015.svg";